import { snapshot } from 'valtio';
import settingsService from '../services';
import InviteMemberStore from '../stores/invite-user-store';
import RevokeInvitationStore from '../stores/revoke-invitation-store';
import { closeRevokeInvitationModal } from '../store-actions/revoke-invitation-store-actions';
import { closeResendInvitationModal } from '../store-actions/resend-invitation-store-actions';

export const revokeInvitation = async (invitationId: string): Promise<void> => {
  try {
    RevokeInvitationStore.isLoading = true;
    const revokedSuccessfully = await settingsService.revokeInvitation.execute(
      invitationId,
    );

    if (!revokedSuccessfully) {
      return;
    }

    const { pendingInvitationMembers } = snapshot(InviteMemberStore);
    InviteMemberStore.pendingInvitationMembers =
      pendingInvitationMembers.filter(p => p.id !== invitationId);
  } catch {
  } finally {
    closeRevokeInvitationModal();
    closeResendInvitationModal();
    RevokeInvitationStore.isLoading = false;
  }
};
